import React, {useState, useEffect} from "react";
import useFetchServiceChecklists from "../hooks/useFetchServiceChecklists";
import ServiceChecklistEditor from "./ServiceChecklistEditor";
import useDispatchServiceChecklist from "../hooks/useDispatchServiceChecklist";
import ServiceListing from "./ServiceListing";
import useCountryAxiosInstance from "../hooks/useCountryAxiosInstance";
import CountryContext from "../CountryContext";
import { useContext } from "react";


const PAGE_SIZE = 10;


const ServiceChecklistListing = ({ serviceId, submittingChecklist, data }) => {

  // hooks
  const fetchChecklists = useFetchServiceChecklists(serviceId, PAGE_SIZE);
  const dispatchChecklist = useDispatchServiceChecklist(serviceId);
  const {country} = useContext(CountryContext);
  const countryApiRequest = useCountryAxiosInstance(country?.code);

  // state
  const [selectedChecklist, setSelectedChecklist] = useState(null);
  const [edits, setEdits] = useState(0);
  const [service, setService] = useState();

  useEffect(async () => {
    const r = await countryApiRequest.get(`/services/${serviceId}`);
    setService(r);
  }, [serviceId]);


  return <>
    {/* --------------- Listing --------------- */}
    <ServiceListing
      edits={edits}
      setEdits={setEdits}
      onFetch={fetchChecklists}
      onClone={async (c) => { await dispatchChecklist(null, c); }}
      onOpen={(c) => { setSelectedChecklist(c); }}
      creatingNew={submittingChecklist}
      pageSize={PAGE_SIZE}
      cloneSuccessMessageId="checklist_cloned_successfully"
      noItemsMessageId="checklists_empty_list_message"
    />
    {/* --------------- Sidebar editor --------------- */}
    {!!selectedChecklist && service &&
      <div className="animate-slideIn w-3/4 md:w-1/2 lg:w-1/3 fixed inset-y-0 right-0 bg-white overflow-y-auto px-6 pb-6 shadow-2xl">
        <ServiceChecklistEditor
          {...{
            service,
            selectedChecklist,
            setSelectedChecklist,
            setEdits,
            data
          }}
        />
      </div>
    }
  </>
}

export default ServiceChecklistListing;